// extracted by mini-css-extract-plugin
export var bigText = "Breadcrumbs-module--big-text--cc879";
export var breadcrumbs = "Breadcrumbs-module--breadcrumbs--18a26";
export var home = "Breadcrumbs-module--home--09460";
export var layout = "Breadcrumbs-module--layout--02b51";
export var link = "Breadcrumbs-module--link--4335b";
export var list = "Breadcrumbs-module--list--e2454";
export var richText = "Breadcrumbs-module--rich-text--563c4";
export var text = "Breadcrumbs-module--text--3816b";